<div class="ui layout">
    <div class="sidebar">
        <app-profile-card [model]="employee"></app-profile-card>
    </div>
    <div class="content">
        <!-- Simply Benefits Card/Enrollment -->
        <div class="ui segment">
            <app-segment-header title="employees.benefits.simplyBenefits"></app-segment-header>
            <!-- Empty -->
            <div *ngIf="!employee?.hasSimplyBenefits" class="empty">
                <img src="/assets/illustrations/benefits.png" />
                <h2 class="ui centered header">
                    {{ 'employees.benefits.noBenefitsHaveBeenAssignedToThisEmployee' | appTranslate }}
                    <div class="sub header">
                        <a
                            class="margin-y-2"
                            [attr.data-cy]="'view-more-simply-link'"
                            href="{{ simplyBenefitsAdminUrl }}"
                            (click)="trackSimplyPortalLinkEvent()"
                            target="_blank"
                            >{{
                                'benefits.components.benefit-details-simply-benefits.viewMoreBenefitDetails'
                                    | appTranslate
                            }}
                            <mat-icon svgIcon="openInNew"></mat-icon
                        ></a>
                    </div>
                </h2>
            </div>

            <div *ngIf="employee?.hasSimplyBenefits" class="flex middle start">
                <div class="inner flex start middle">
                    <div class="ui static form">
                        <div class="inline field">
                            <label>{{ 'benefits.benefitClass' | appTranslate }}</label>
                            {{ benefitClass ?? ('na' | appTranslate) }}
                        </div>
                        <div class="inline field">
                            <label>{{ 'benefits.division' | appTranslate }}</label>
                            {{ division ?? ('na' | appTranslate) }}
                        </div>
                        <div class="inline field">
                            <label>{{ 'benefits.eligibilityPeriod' | appTranslate }}</label>
                            {{ waiveEligibilityPeriod ?? 'na' | appTranslate }}
                        </div>

                        <a
                            class="margin-y-2"
                            [attr.data-cy]="'view-more-simply-link'"
                            href="{{ simplyBenefitsAdminUrl }}"
                            (click)="trackSimplyPortalLinkEvent()"
                            target="_blank"
                            >{{
                                'benefits.components.benefit-details-simply-benefits.viewMoreBenefitDetails'
                                    | appTranslate
                            }}
                            <mat-icon svgIcon="openInNew"></mat-icon
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
